import { useEffect, useState } from "react";
import { Accordion, Card, Col } from "react-bootstrap";
import { MdArrowDropDown, MdClose } from "react-icons/md";

import Description from "../Description/Description";

import "./DataSheetAccordion.css";
import DataSheetEntitie from "../../models/DataSheetEntitie";
import Util from "../../utils/Util";
import i18n from "../../i18n";
import { NameSpace } from "../../data/AppLanguage";
import { useTranslation } from "react-i18next";
import dataTransferDownIcon from '../../assets/icons/cil-data-transfer-down.svg';
import { useHistory } from "react-router-dom";


interface Props {
  title: string;
  dataSheetsDescription: DataSheetEntitie[];
  className?: string;
}

const DataSheetAccordion = (props: Props) => {
  const [clicked, setClicked] = useState(false);
  const [dataSheetId, setDataSheetId] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  const language = Util.splitLanguage(i18n.language, 0);
  const { t } = useTranslation([NameSpace.COMMON, NameSpace.PAGES]);
 
  const history = useHistory();
  const storage = localStorage;

  useEffect(() => {
    if(dataSheetId){
      setIsLoading(true);
      const id = String(dataSheetId);
      storage.setItem('dataSheetId', id)
      history.push(`/${language}/pdfGenerator`)
    }
  },[dataSheetId])

  return (
    <Accordion>
      <Card
        className={`family-accordion border-left-0 border-right-0 p-2 ${props.className}`}
      >
        <Card.Body className="p-0" onClick={() => setClicked(!clicked)}>
          <Accordion.Toggle
            eventKey="0"
            className="border-0 p-0 bg-transparent w-100 text-left"
          >
            <span className="family-accordion-title">{props.title}</span>

            {clicked ? (
              <MdClose className="family-accordion-icon" />
            ) : (
              <MdArrowDropDown className="family-accordion-icon" />
            )}
          </Accordion.Toggle>
        </Card.Body>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="pl-0 pb-0 pt-0 mt-3">
            {props.dataSheetsDescription && props.dataSheetsDescription.map((item, index) => {
              return (               
                <Col               
                className="button-download-datasheet p-0"    
                style={{ justifyContent: "left", alignContent: "left", textAlign: "left" }}
                  key={index}
                >
                  {                
                    item.dataSheetTranslations[0]?.languageId === language.toLocaleUpperCase() ? 
                      <button 
                      className="btns default p-0 pl-1 button-download-datasheet"  
                      style={{ 
                        width: "100%",
                        justifyContent: "left", 
                        alignContent: "left", 
                        textAlign: "left" ,
                        fontSize: "12px"
                      }}
                      key={item.id}
                      value={item.id}
                      onClick={() => setDataSheetId(item.id)}                    
                    >
                      <img src={dataTransferDownIcon} alt="Download Icon" className="icon" style={{ width: "1em"}} />
                      {
                        item.datasheet_type_id == 2 ? 
                        ( !isLoading ? `${item.dataSheetTranslations[0]?.subtitleText} -  ${item.dataSheetTranslations[0]?.textFooter1}` : t("contactForm.loading", { ns: NameSpace.COMMON })) 
                        : 
                        (!isLoading ?  `${item.dataSheetTranslations[0]?.subtitleText}` : t("contactForm.loading", { ns: NameSpace.COMMON }))
                      }
                     
                     
                      {}
                    </button>
                    : ''
                  }              
                </Col>
              );
            })}
           
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default DataSheetAccordion;

 {/* {props.dataSheets && props.dataSheets.map((item, index) => {
          return (
            <Col               
            className="button-download-datasheet p-0"    
            style={{ justifyContent: "left", alignContent: "left", textAlign: "left" }}
              key={index}
            >
              {                
                item.dataSheetTranslations[0]?.languageId === language.toLocaleUpperCase() ? 
                  <button 
                  className="btns default p-0 pl-1 button-download-datasheet"  
                  style={{ 
                    width: "100%",
                    justifyContent: "left", 
                    alignContent: "left", 
                    textAlign: "left" ,
                    fontSize: "12px"
                  }}
                  key={item.id}
                  value={item.id}
                  onClick={() => setDataSheetId(item.id)}                    
                >
                  <img src={dataTransferDownIcon} alt="Download Icon" className="icon" style={{ width: "1em"}} />
                  {!isLoading ? item.dataSheetTranslations[0]?.subtitleText : t("contactForm.loading", { ns: NameSpace.COMMON })}
                </button>
                : ''
              }              
            </Col>
          );
        })} */}